import { Tag, Button } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

/**
 * createColumns
 * Complemento para mostrar las tablas tanto como en antd y modo responsive
 * @param {Function} showEditModal
 * @param {Function} showDeleteModal
 * @param {Number} page
 */
export function createColumns(page = 1, showEditModal = null, showDeleteModal = null) {
  return [
    {
      title: "N.º",
      key: "index",
      render: (value, item, index) => (page - 1) * 10 + index + 1
    },
    {
      title: "Usuario",
      dataIndex: "username",
      key: "username",
      sorter: (a, b) => a.username.localeCompare(b.username)
    },
    {
      title: "DNI",
      dataIndex: "documentNumber",
      key: "documentNumber",
      sorter: (a, b) => a.documentNumber - b.documentNumber
    },
    {
      title: "Nombres",
      dataIndex: "firstName",
      key: "firstName",
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Apellidos",
      dataIndex: "lastName",
      key: "lastName",
      sorter: (a, b) => a.lastName.localeCompare(b.lastName),
      sortDirections: ["descend", "ascend"]
    },
    {
      title: "Rol",
      dataIndex: "role",
      key: "role",
      render: (role) => {
        let color = "";
        let text = "";
        switch (role) {
          case "admin":
            color = "volcano";
            text = "Administrador";
            break;
          case "organizer":
            color = "green";
            text = "Organizador";
            break;
          default:
            break;
        }
        return (
          <Tag color={color} key={role}>
            {text}
          </Tag>
        );
      },

      filters: [
        {
          text: "Administador",
          value: "admin"
        },
        {
          text: "Organizador",
          value: "organizer"
        }
      ],
      filterMultiple: true,
      onFilter: (value, record) => record.role.indexOf(value) === 0,
      sorter: (a, b) => {
        return a.role.length - b.role.length;
      },
      sortDirections: ["descend", "ascend"]
    },
    // {
    //   title: "Celular",
    //   dataIndex: "phoneNumber",
    //   key: "phoneNumber",
    //   sorter: (a, b) => a.phoneNumber - b.phoneNumber,
    // },
    {
      title: "Acciones",
      key: "action",
      render: (record) => (
        <span>
          <Button icon={<EditOutlined />} onClick={() => showEditModal(record)} />
          &nbsp;
          <Button icon={<DeleteOutlined />} onClick={() => showDeleteModal(record)} />
        </span>
      )
    }
  ];
}
